module.exports = __webpack_public_path__ + "img/airline-loader.40dac39.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/airline-loader.gif
// module id = 1090
// module chunks = 0